import { render, staticRenderFns } from "./CustomerReservation.vue?vue&type=template&id=f79fed4e&scoped=true&"
import script from "./CustomerReservation.vue?vue&type=script&lang=js&"
export * from "./CustomerReservation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReservation.vue?vue&type=style&index=0&id=f79fed4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79fed4e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/CustomerReservation.vue
// module id = null
// module chunks = 